import { cn } from "@src/lib/utils";
function Skeleton({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="skeleton" className={cn("bg-accent animate-pulse rounded-md", className)} {...props} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx" />;
}
export { Skeleton };